export enum BeneficioSocial {
  SEGURO_DESEMPREGO = 'SEGURO_DESEMPREGO',
  AUXILIO_DOENCA = 'AUXILIO_DOENCA',
  BOLSA_FAMILIA = 'BOLSA_FAMILIA',
  TARIFA_SOCIAL_ENERGIA_ELETRICA = 'TARIFA_SOCIAL_ENERGIA_ELETRICA',
  CARTEIRA_IDOSO = 'CARTEIRA_IDOSO',
  IDENTIDADE_JOVEM = 'IDENTIDADE_JOVEM',
  BPC_LOAS = 'BPC_LOAS',
}
